if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this.isDragging = false;
      this.startX = 0;
      this.scrollStart = 0;
      this.cardWidth = 0; // Added to calculate individual card width
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
      this.enableDragScroll();
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add("m-promotion--animated");

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }

        // Pause when out of view
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this);
      }

      // Calculate card width for precise scrolling
      this.cardWidth = this.querySelector(".m-promotion__item")?.offsetWidth || 0;
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }

    enableDragScroll() {
      this.addEventListener("mousedown", (e) => {
        this.isDragging = true;
        this.classList.add("dragging");
        this.startX = e.pageX - this.offsetLeft;
        this.scrollStart = this.scrollLeft;

        // Prevent text selection during dragging
        e.preventDefault();
      });

      this.addEventListener("mousemove", (e) => {
        if (!this.isDragging) return;
        const x = e.pageX - this.offsetLeft;
        const scrollDelta = x - this.startX;

        // Adjust scroll position softly, card by card
        const scrollOffset = Math.round(scrollDelta / this.cardWidth) * this.cardWidth;
        this.scrollLeft = this.scrollStart - scrollOffset;

        // Pause animation while dragging
        this.classList.add("m-scrolling-promotion--paused");
      });

      this.addEventListener("mouseup", () => {
        this.isDragging = false;
        this.classList.remove("dragging");
        this.classList.remove("m-scrolling-promotion--paused");

        // Snap to the nearest card
        this.scrollLeft = Math.round(this.scrollLeft / this.cardWidth) * this.cardWidth;
      });

      this.addEventListener("mouseleave", () => {
        this.isDragging = false;
        this.classList.remove("dragging");
      });

      // Prevent native drag behavior
      this.addEventListener("dragstart", (e) => {
        e.preventDefault();
      });
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}
